import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi'; // Correct path
import { risapi } from './risapi'; // Correct path

export const getGrns = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/grns', filterParameters), getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { handleApiError(error); callback({ error }); }
};

export const fetchGrn = async (id, callback) => {
    try {
        const response = await risapi.get(`/api/grns/${id}`, getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { handleApiError(error); callback({ error }); }
};

// ** Fetch data needed to PRE-POPULATE the create form **
export const fetchGrnPrepopulationData = async (sourceType, sourceId, callback) => {
     try {
         // Pass source info as query parameters to the create route
         const url = `/api/grns/create?source_type=${encodeURIComponent(sourceType)}&source_id=${encodeURIComponent(sourceId)}`;
         const response = await risapi.get(url, getAxiosConfig());
         if (response.status === 200) callback(response.data); // Returns { prepopulation_data: { source: {}, items: [] } }
     } catch (error) { handleApiError(error); callback({ error }); }
 };


export const createGrn = async (newData, callback) => {
    try {
        // Send as JSON
        const response = await risapi.post('/api/grns', newData, getAxiosConfig());
        if (response.status === 201) callback(response.data);
    } catch (error) { callback(error); } // Let form handle validation
};

export const updateGrn = async (editData, callback) => {
    try {
        // Send as JSON
        const response = await risapi.put(`/api/grns/${editData.id}`, editData, getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { callback(error); } // Let form handle validation
};

export const destroyGrn = async (itemToDelete, callback) => {
    try {
        const response = await risapi.delete(`/api/grns/${itemToDelete.id}`, getAxiosConfig());
        if (response.status === 204) callback({ grn: itemToDelete }); // Success
    } catch (error) { callback({ error }); } // Let list page handle conflict/error
};

// --- destroyGrnsMultiple omitted ---